import classNames from 'classnames';
import { ReactNode } from 'react';
import * as bd from 'react-basic-design';

type LoadingButtonProps = {
    variant?: '' | 'inherit' | 'contained' | 'flat' | 'icon' | 'text' | 'outline' | 'fab';
    className?: string;
    color?: '' | 'inherit' | 'default' | 'primary' | 'secondary';
    size?: '' | 'sm' | 'md' | 'lg';

    label: ReactNode;
    icon?: ReactNode;
    disableRipple?: boolean;
    disabled?: boolean;
    loading?: boolean;
    isValid?: boolean;
    [x: string]: any;
};

export const LoadingButton = ({
    variant,
    label,
    icon,
    disabled,
    loading,
    isValid = true,
    className = '',
    size = 'md',
    disableRipple = false,
    ...props
}: LoadingButtonProps) => {
    return (
        <bd.Button
            variant={variant}
            className={classNames(className, 'min-w-80')}
            size={size}
            disableRipple={disableRipple}
            {...props}
            disabled={disabled || !isValid || loading}
        >
            {loading && <div className="m-e-2 spinner-border spinner-border-sm"></div>}
            {!loading && icon}
            {label}
        </bd.Button>
    );
};
